import { useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks, BookmarkPlus, Trash2 } from "lucide-react";
import { PageHeader } from "@/components/control/PageHeader";
import { TaskPanel } from "@/components/control/TaskPanel";
import { useLoad, RunButton } from "@/components/control/kit";
import { api } from "@/lib/api";
import { TASK_VIEW_LABELS as L } from "@/pages/SaveView";

const filt = (v) => ({ country: v?.filters?.country || "all", scope: v?.filters?.scope || "open" });

// C29 + C31: own tasks, optionally filtered by a saved work view (country + scope).
function ViewChips({ st, active, setActive }) {
  const views = st.data?.views || [];
  if (!views.length) return null;
  const chip = (on) => `rounded-full border px-3 py-1.5 text-sm font-semibold ${on ? "border-brand-purple bg-brand-purple text-white" : "border-[#E6E1F0] bg-white text-brand-purple"}`;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2" data-testid="saved-views">
      <span className="text-sm font-semibold text-zinc-600">Arbeitsansichten:</span>
      <button type="button" className={chip(!active)} onClick={() => setActive(null)} data-testid="saved-view-none">Standard</button>
      {views.map((v) => (
        <span key={v.id} className="inline-flex items-center gap-1">
          <button type="button" className={chip(active?.id === v.id)} onClick={() => setActive(v)} data-testid={`saved-view-${v.id}`}
            title={`${L.country[filt(v).country]} · ${L.scope[filt(v).scope]} · ${L.visibility[v.visibility] || ""}`}>{v.name}</button>
          {v.mine && <RunButton label="Löschen" icon={Trash2} testId={`delete-saved-view-${v.id}`} success="Ansicht gelöscht."
            onDone={() => { if (active?.id === v.id) setActive(null); st.reload(); }} run={() => api.delete(`/saved-views/${v.id}`)} />}
        </span>
      ))}
    </div>
  );
}

export default function MyTasks() {
  const st = useLoad("/saved-views?area=aufgaben");
  const [active, setActive] = useState(null);
  return (
    <div>
      <PageHeader title="Meine Aufgaben" subtitle="Offene, zugewiesene und erledigte Vorgänge aus allen Bereichen, für die du berechtigt bist." icon={ListChecks}
        actions={<Link to="/aufgaben/ansicht-speichern" data-testid="save-view-link"
          className="inline-flex items-center gap-2 rounded-lg border border-brand-purple/30 bg-white px-3 py-2 text-sm font-semibold text-brand-purple hover:bg-secondary">
          <BookmarkPlus className="h-4 w-4" aria-hidden="true" />Arbeitsansicht speichern</Link>} />
      <ViewChips st={st} active={active} setActive={setActive} />
      {active && <p className="mb-3 text-sm text-zinc-600" data-testid="saved-view-active">Filter: {L.country[filt(active).country]} · {L.scope[filt(active).scope]}.
        {filt(active).country !== "all" && " Vorgänge ohne Länderangabe erscheinen nur bei «Alle Länder»."}</p>}
      <TaskPanel key={active?.id || "default"} initialScope={filt(active).scope} country={filt(active).country} />
    </div>
  );
}
